import * as React from "react";
import PropTypes from 'prop-types';

const SvgWallet = props => {
  if (props.id !== "_svgwallet") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 32 32" {...props}><path fillRule="evenodd" d="M25.857 9.273c1.178 0 2.143.957 2.143 2.126v2.677h-6c-.98 0-1.843.418-2.429 1.175-.505.652-.783 1.514-.783 2.428 0 1.757 1.103 3.536 3.212 3.536h6v2.66A2.14 2.14 0 0125.857 26H6.142A2.14 2.14 0 014 23.874V11.4a2.14 2.14 0 012.142-2.126h19.715zM28 15.271v4.75h-6c-1.39 0-2.012-1.176-2.012-2.342 0-.642.194-1.26.533-1.699.364-.47.861-.709 1.48-.709h6zm-4.6.967c-.773 0-1.4.624-1.4 1.393 0 .77.627 1.394 1.4 1.394.772 0 1.4-.624 1.4-1.394 0-.769-.628-1.393-1.4-1.393zM22.74 6c1.213 0 2.26.858 2.485 2.041l.113.59.01.045H8.132l14.135-2.632c.154-.03.313-.044.471-.044z" /></svg>;
};

SvgWallet.displayName = "_svgwallet";
SvgWallet.propTypes = {
  id: PropTypes.string
};
SvgWallet.defaultProps = {
  id: ''
};
export default SvgWallet;